import { createContext } from 'preact';

export const IntlContext = createContext({ intl: {} });
